<template>
  <div class="page page-devices content">
    <IconSpinner
      v-if="!devicesLoaded"
      :extra-classes="['page-devices__spinner']"
    />
    <DeviceDetail v-else :device="device" />
  </div>
</template>

<script>
  import DeviceDetail from '@/components/devices/DeviceDetail'
  import IconSpinner from '@/components/icons/Spinner'

  export default {
    name: 'page-device-detail',
    components: {
      DeviceDetail,
      IconSpinner,
    },
    data() {
      return {
        devicesLoaded: false,
      }
    },
    created() {
      this.devicesLoaded = this.devicesLoadedFromStore
    },
    computed: {
      devicesLoadedFromStore() {
        return this.$store.getters.devicesLoaded
      },
      device() {
        const deviceId = parseInt(this.$router.currentRoute.params.deviceid)
        return this.$store.getters.deviceById(deviceId)
      },
    },
    watch: {
      devicesLoadedFromStore(newValue) {
        this.devicesLoaded = newValue
      },
    },
  }
</script>

<style lang="scss">
  .page-devices {
    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 2rem;
      height: 2rem;
      animation: spin 1.8s linear 0s infinite;
    }
  }
</style>
